module.exports = __webpack_public_path__ + "fonts/inter-v11-latin-100.8293dd1.eot";